/* launchRef.js */

"use strict";

const _ = require("lodash");

let _buildFilterString = (typesArray) => {
    let terms = typesArray.map((typeName) => `Type eq ${typeName}`);
    return terms.join(" or ");
};

let launchRef = function (scope, construct, types, refItems, fcd) {
    let launchObj = {
        construct: construct,
    };

    if (!_.isEmpty(refItems)) {
        launchObj.instanceIds = [];
        launchObj.instances = [];
        let selectedTypes = [];

        refItems.forEach((item, idx) => {
            launchObj.instanceIds.push(item.instanceId);
            launchObj.instances.push({
                instanceId: item.instanceId,
                instanceName: item.instanceName,
            });
            selectedTypes.push(types[idx]);
        });
        selectedTypes = _.uniq(selectedTypes);
        if (selectedTypes.length > 1) {
            launchObj.filter = _buildFilterString(selectedTypes);
        } else if (selectedTypes.length === 1) {
            launchObj.type = selectedTypes[0];
            launchObj.filter = "";
        }
    } else {
        if (types.length > 1) {
            launchObj.filter = _buildFilterString(types);
        } else {
            launchObj.type = types[0];
            launchObj.filter = "";
        }
    }

    scope.$emit("instance.launchRef", launchObj);
    scope.$emit("RefLaunched", {
        launchObj: launchObj,
        configData: fcd.configData,
        configSettings: fcd.configSettings,
        refInstances: fcd.refInstances,
    });
};

module.exports = launchRef;
